import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PrivateSection from "routes/PrivateSection";
import PublicRoutes from "routes/PublicRoutes";
import { useAuthStore } from "@/stores/auth-store";

function Routes() {
  const { pathname } = useLocation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const userRoles = useAuthStore((s) => s.getUserRolesAsNumbers);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return isAuthenticated ? (
    <PrivateSection userRole={userRoles()} />
  ) : (
    <PublicRoutes />
  );
}

export default Routes;
